import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import AICapabilities from "../components/AICapabilities";
import About from "../components/About";
import Stats from "../components/Stats";
import Services from "../components/Services";
import Testimonials from "../components/Testimonials";
import Expertise from "../components/Expertise";
import TechStack from "../components/TechStack";
import Clients from "../components/Clients";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import ScrollProgress from "../components/ScrollProgress";
import AuroraBackground from "../components/AuroraBackground";
import SectionDots from "../components/SectionDots";

export default function HomePage() {
  return (
    <div className="relative bg-white text-[#333333] overflow-hidden">
      <ScrollProgress />
      <AuroraBackground />
      <SectionDots />
      <Navbar />
      <Hero />
      <AICapabilities />
      <About />
      <Stats />
      <Services />
      <Expertise />
      <Clients />
      <Testimonials />
      <TechStack />
      <Contact />
      <Footer />
    </div>
  );
}
